import { render, staticRenderFns } from "./invoiceMessageAdd.vue?vue&type=template&id=490bf9ac&scoped=true"
import script from "./invoiceMessageAdd.vue?vue&type=script&lang=js"
export * from "./invoiceMessageAdd.vue?vue&type=script&lang=js"
import style0 from "./invoiceMessageAdd.vue?vue&type=style&index=0&id=490bf9ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490bf9ac",
  null
  
)

export default component.exports